import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '../../services/event.service';
import { WindowService } from 'src/app/services/window.service';
import { UpdateProvider } from '../../providers/update/update.provider'
import { UserStore } from 'src/app/stores/user.store';
import { ResourceStore } from 'src/app/stores/resources.store';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { Subject, takeUntil, map, Observable } from 'rxjs';
import { User } from 'src/app/models/user';
import { AccountProvider } from 'src/app/providers/account/account';
// import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { plainToClass } from 'class-transformer';
import { Resources } from 'src/app/models/resources';
import { Teacher } from 'src/app/models/teacher';
import { Lesson } from 'src/app/models/lesson';
import { Course } from 'src/app/models/course';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
// import { Lesson } from 'src/app/models/lesson';

import * as Sentry from '@sentry/browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit, OnDestroy {

  username: string;
  password: string;
  waitingToLogin: boolean;
  invalidLogin: boolean;
  height: number = 1024

  ngUnsubscribeTeacher = new Subject();
  ngUnsubscribeResources = new Subject();

  hasResources: boolean = false;
  hasTeacher: boolean = false;

  constructor(private router: Router,
              private eventService: EventService,
              private windowService: WindowService,
              private updateProvider: UpdateProvider,
              private accountProvider: AccountProvider,
              private resourcesProvider: ResourcesProvider,
              private userStore: UserStore,
              private resourceStore: ResourceStore,
              private teacherStore: TeacherStore) {

    this.invalidLogin = false
    this.waitingToLogin = false

    this.windowService.height$.subscribe((height: number) => this.height = height)

    this.eventService.loggingInErrorSource$.subscribe(() => {
      this.loginFailed()
    })

    this.eventService.loggedInSource$.subscribe(() => {
      this.loginSucceeded()
    })

    this.userStore.state$
        .pipe(
            takeUntil(this.ngUnsubscribeTeacher),
            map((user: User) => {
                const token = localStorage.getItem('token');
                if (user.email != null && token != null && token.length > 0) {
                    this.router.navigateByUrl('lesson-plans');
                }
            })
        )
        .subscribe(data => {
        });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.ngUnsubscribeTeacher.next(null);
    this.ngUnsubscribeTeacher.complete();

    this.ngUnsubscribeResources.next(null);
    this.ngUnsubscribeResources.complete();
  }

  findTrainingCenter() {
    window.open('https://www.musictogether.com/events-registration', '_blank');
  }

  forgotPassword() {
    window.open('https://auth.musictogether.com/Account/BeginPasswordReset', '_blank')
  }

  loginUser() {
    this.waitingToLogin = true
    this.invalidLogin = false

    if (!this.username || !this.password) {
      this.loginFailed()
      return
    }

    this.accountProvider.loginUser(this.username, this.password).subscribe((response: any) => {
      const token = response.headers.get('authorization')
      localStorage.setItem('token', token);

      const teacher = this.copyTeacherFrom(response.body.data);

      try {
        Sentry.setContext('teacher', {
          name: teacher?.user?.name || '',
          email: teacher?.user?.email || '',
          uuid: teacher?.user?.uuid
        });        
      } catch (exc) {

      }

      
      this.teacherStore.setTeacher(teacher).then(() => {
        this.resourcesProvider.getResources().subscribe((resources: Resources) => {
          if (resources == null) {
            resources = this.copyResourcesFrom(response.body.data);
          }
          this.resourceStore.setResources(resources).then(() => {
            this.userStore.loginUser(teacher.user).then(() => {
              this.loginSucceeded()
            })
          })
        })        
      })      
    },
    (error: any)=>{
      console.log("Error in login",error)
      this.loginFailed()
    });
  }


  private copyResourcesFrom(data: Object) {
    const resources: Resources = plainToClass(Resources, data || Resources.defaults()) as any  // forced cast because type inference is wrong    
    resources.classTypes ||= [];
    resources.parentEducationMoments ||= [];
    resources.teachingTools ||= [];
    resources.trainings ||= [];
    resources.videos ||= [];
    return resources;
  }

  private copyTeacherFrom(data: Object) {
    const teacher: Teacher = plainToClass(Teacher, data || {}) as any  // forced cast because type inference is wrong
    teacher.customPems ||= [];
    teacher.lessonsBeingEdited ||= new Map<string, Lesson>();
    teacher.coursesBeingEdited ||= new Map<string, Course>();
    teacher.pages ||= [];
    teacher.resourcePages ||= [];
    teacher.articles ||= [];
    teacher.resetSendDate();
    return teacher;
  }

  logoVisible() {
    return this.height >= 400 && (!this.invalidLogin || this.height >= 500)
  }

  trainingVisible() {
    return this.height >= 500 && (!this.invalidLogin || this.height >= 600)
  }

  friendsVisible() {
    return this.height >= 600 && (!this.invalidLogin || this.height >= 700)
  }


  loginSucceeded() {
    this.waitingToLogin = false
    this.invalidLogin = false
    if (this.updateProvider.hasUpdate) {
      this.updateProvider.activateUpdate()
    } else {



      let redirect: string = location.search
      let segments = redirect?.split('&')
      redirect = null
      segments.forEach((segment: string) => {
        if (segment.includes('redirect=')) {
          redirect = decodeURIComponent(segment.replace('?', '').replace('redirect=', ''))
          while (redirect.startsWith('/')) {
            redirect = redirect.slice(1)
          }
        }
      })
      this.router.navigateByUrl(redirect || 'lesson-plans')      
    }
  }

  resetLogin() {
    this.invalidLogin = false
  }

  loginFailed() {
    this.waitingToLogin = false
    this.invalidLogin = true
  }
}
